import { gql } from '@apollo/client'

export const GET_TOP_BRANDS_QUERY = gql`
  query getTopBrands {
    getWorkspace {
      id
      topBrandSOAByWorkspace {
        topBrandSOAPaginated {
          data {
            id
            brand {
              id
              name
              brandColor
            }
            category {
              id
              name
            }
            thumbnail
            weeklySOAMetric {
              date
              value
              valueVariation
              rank
              rankVariation
            }
            dailySOAMetric {
              date
              value
              valueVariation
              rank
              rankVariation
            }
            monthlySOAMetric {
              date
              value
              valueVariation
              rank
              rankVariation
            }
            last3Month {
              date
              value
              valueVariation
              rank
              rankVariation
            }
            last6Month {
              date
              value
              valueVariation
              rank
              rankVariation
            }
            last12Month {
              date
              value
              valueVariation
              rank
              rankVariation
            }
          }
          cursor
          totalCount
        }
        selfBrandSOA {
          id
          thumbnail
          brand {
            id
            name
            brandColor
          }
          category {
            id
            name
          }
          weeklySOAMetric {
            date
            value
            valueVariation
            rank
            rankVariation
          }
          dailySOAMetric {
            date
            value
            valueVariation
            rank
            rankVariation
          }
          monthlySOAMetric {
            date
            value
            valueVariation
            rank
            rankVariation
          }
          last3Month {
            date
            value
            valueVariation
            rank
            rankVariation
          }
          last6Month {
            date
            value
            valueVariation
            rank
            rankVariation
          }
          last12Month {
            date
            value
            valueVariation
            rank
            rankVariation
          }
        }
      }
    }
  }
`
